export default __webpack_public_path__ + "static/Moniqa-MediumHeading-bf1d0e52af37b1b3ef91e15dd37a360e.woff";